/**
 * A board row's List group cell: each group today's plan carries, its chip opening its lists
 * (the planner's own view). 27/10/2026 (user, after a paste: "I see no list group nothing. is
 * that normal?") — a container today's plan doesn't carry (switched off — a pasted one arrives
 * off — or not run today) still shows the groups it links, muted, each chip opening all of its
 * lists; "—" only when it links none.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DayPlanGroupRow, DropGenGroupLite } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import type { BoardGroupRow } from '../board-list-rows';
import { GroupListsPopover } from '../GroupListsPopover';

/** A linked group with no day behind it: no list of the day, nothing skipped — its pop-up opens on All. */
export const linkedGroupRow = (g: DropGenGroupLite): DayPlanGroupRow => ({
  listGroupId: g.listGroupId,
  groupName: g.groupName,
  groupColor: g.groupColor,
  listOfDay: null,
  skipped: [],
  next: null,
  paused: null,
});

interface Props {
  /** Today's groups (the day plan's). */
  groups: BoardGroupRow[];
  /** The groups the container links, in link order. */
  linked: DropGenGroupLite[];
  campaignWiserId: number;
}

export const GroupCell: FC<Props> = ({ groups, linked, campaignWiserId }) => {
  const today = groups.length > 0;
  const rows: DayPlanGroupRow[] = today ? groups : linked.map(linkedGroupRow);
  if (rows.length === 0) return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <span className={cn('flex min-w-0 flex-col gap-0.5 text-xs', !today && 'opacity-60')} title={today ? undefined : 'Linked — nothing from it is planned today'}>
      {rows.map((group) => (
        <span key={group.listGroupId} className="flex min-w-0 items-start">
          <GroupListsPopover group={group} campaignWiserId={campaignWiserId} />
        </span>
      ))}
    </span>
  );
};
